import { createSlice } from '@reduxjs/toolkit';
import { addStudyMarking } from '../../../rtk-apis/reports/addStudyMarkingApi';

const initialState = {
  status: '',
  data: '',
  msg: '',
  loading: false,
};

const addStudyMarkingSlice = createSlice({
  name: 'addStudyMarkingSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.data = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(addStudyMarking.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addStudyMarking.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload?.data;
        state.msg = action?.payload?.msg;
      })
      .addCase(addStudyMarking.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.data = '';
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default addStudyMarkingSlice.reducer;
export const { clearState } = addStudyMarkingSlice.actions;
